<template>
  <Modal
    :is-visible="showModal"
    title="Delete this wishlist?"
    wrapper-class="modal-wishlists"
    @onClose="close"
  >
    <template #body>
      <p class="delete-wishlist-body">
        Once you delete, you can’t undo this action. Delete <strong>{{ listName }}</strong>?
      </p>
    </template>

    <template #footer>
      <button
        type="button"
        class="btn btn-outline-secondary mr-3"
        @click.prevent="close"
      >
        Back
      </button>
      <button
        type="button"
        class="btn btn-danger"
        @click.prevent="confirm"
      >
        Yes, delete
      </button>
    </template>
  </Modal>
</template>
<script>
import Modal from '~/components/common/Modal.vue';

export default {
  components: {
    Modal,
  },
  props: {
    listName: {
      type: String,
      required: true,
    },
    showModal: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    close() {
      // emit close event
      this.$emit('close');
    },
    confirm() {
      // emit confirm event
      this.$emit('confirm');
    },
  },
};
</script>
<style lang="scss" scoped>
  @import '~/styles/dorado/main';
</style>
